'use strict';

import 'regenerator-runtime/runtime';
import {callbackOnElements} from '@borngroup/born-utilities';
import {executeVerification} from '../helpers/reCaptcha.js';

function setupRecaptcha(currentForm) {
    currentForm.addEventListener('submit', async(e) => {
        if (currentForm.dataset.captchaExecuted) {
            currentForm.dataset.captchaExecuted = false;
        } else {
            e.preventDefault();
            await executeVerification();
            currentForm.dataset.captchaExecuted = true;
            currentForm.submit();
        }
    });
}

export function init(options) {
    if (window.SFRA.SitePreferences.enableGoogleRecaptcha) {
        callbackOnElements(options.elements, setupRecaptcha);
    }
}
